// extracted by mini-css-extract-plugin
export var labelWrapper = "_bq-0";